import {Div, Label} from 'components';
import {Ecolors} from 'constant';
import {Parser} from 'html-to-react';
import React, {useEffect, useState} from 'react';
import {apiMain} from 'services/apis/apiMain';
function ConfirmContent(p: {email?: string}) {
  const [content, setContent] = useState<string>('');
  useEffect(() => {
    getData();
    return () => {};
  }, []);

  const getData = async () => {
    try {
      p.email?.replace;
      const r = await apiMain.getConfirmContent();
      if (r.status == 200) {
        setContent(
          r.data.content?.replace(new RegExp('<p>&nbsp;</p>', 'g'), ''),
        );
      }
    } catch (error) {}
  };

  return (
    <Div backgroundColor={Ecolors.bgtime}>
      <Div paddingHorizontal={16} paddingTop={16}>
        <Label>{`accountverify.titleconfirm`}</Label>
        <Label
          marginTop={5}
          color={Ecolors.mainColor}
          fontWeight={'700'}
          multilanguage={false}
          lineHeight={22}
          size={15}>
          <Label
            lineHeight={22}
            size={15}>{`accountverify.contentdiachi1`}</Label>
          {`${p.email || ''}`}
        </Label>
        {Parser().parse(content)}
      </Div>
    </Div>
  );
}

export default React.memo(ConfirmContent);
